import config from '../store/_config'
import { axiosInstance as axios } from '../../dashboard/_utils'

export const axiosAuthLogin = (params) => {
  let { url, query } = config.authentication.login

  return axios.post(
    url,
    {
      query: query,
      variables: params,
    },
    {
      withCredentials: true,
    }
  )
}

export const axiosAuthLoginWithOTP = (params) => {
  let { url, query } = config.authentication.loginWithOTP

  return axios.post(
    url,
    {
      query: query,
      variables: params,
    },
    {
      withCredentials: true,
    }
  )
}

export const axiosAuthForgetPassword = (params) => {
  let { url, query } = config.authentication.forgetPassword

  return axios.post(
    url,
    {
      query: query,
      variables: params,
    },
    {
      withCredentials: true,
    }
  )
}
export const axiosCreateEvolutionSignup = (postData) => {
  let { url, query } = config.authentication.createSignup

  return axios.post(
    url,
    {
      query: query,
      variables: postData,
    },
    {
      withCredentials: true,
    }
  )
}

export const axioscreateAirwallexCustomerSignup = () => {
  let { url, query } = config.authentication.createAirwallexCustomerSignup

  return axios.post(
    url,
    {
      query: query,
    },
    {
      withCredentials: true,
    }
  )
}

export const axioscreateCreditCard = (postData) => {
  let { url, query } = config.authentication.createAirwallexCreditCard

  return axios.post(
    url,
    {
      query: query,
      variables: postData,
    },
    {
      withCredentials: true,
    }
  )
}

export const triggerDiscount = (memberID = null) => {
  if (window?.isLocalhost) {
    return
  }

  const { triggerDiscount } = config
  let { url, query } = triggerDiscount

  const variables = {}

  if (memberID) {
    variables['ID'] = memberID
  }

  // return axios.post(
  //   url,
  //   {
  //     query,
  //     variables,
  //   },
  //   {
  //     withCredentials: true,
  //   }
  // )
}
